import ericTsang from '../assets/Eric_Tsang.jpg';
import keenaKwok from '../assets/Keena_Kwok.jpg';
import daveTang from '../assets/Dave_Tang.jpg';
import kenSir from '../assets/Ken_Sir.jpg';
import richardTse from '../assets/Richard_Tse.jpg';
import consultantWoman from '../assets/consultant-woman.jpg';
import sallyChan from '../assets/Sally_Chan.jpg';
import leungKamWa from '../assets/Leung_Kam_Wa.jpg';
import alfredAu from '../assets/Alfred_Au.jpg';
import pinkyYau from '../assets/Pinky_Yau.jpg';
import evaMak from '../assets/Eva_Mak.jpg';
import yostinTing from '../assets/_archived_Yostin_Ting.jpg';

/**
 * Maps a consultant `imageUri` (bundled asset filename, as stored in the CMS)
 * to the bundled asset. CMS values may also be data: URLs or absolute
 * http(s) URLs — those bypass this map (see resolveConsultantImage).
 */
export const imageMap: Record<string, string> = {
  'Eric_Tsang.jpg': ericTsang,
  'Keena_Kwok.jpg': keenaKwok,
  'Dave_Tang.jpg': daveTang,
  'Ken_Sir.jpg': kenSir,
  'Richard_Tse.jpg': richardTse,
  'consultant-woman.jpg': consultantWoman,
  'Sally_Chan.jpg': sallyChan,
  'Leung_Kam_Wa.jpg': leungKamWa,
  'Alfred_Au.jpg': alfredAu,
  'Pinky_Yau.jpg': pinkyYau,
  'Eva_Mak.jpg': evaMak,
  '_archived_Yostin_Ting.jpg': yostinTing,
};

export const DEFAULT_CONSULTANT_IMAGE = consultantWoman;

export function resolveConsultantImage(imageUri: string | undefined): string {
  if (!imageUri) return DEFAULT_CONSULTANT_IMAGE;
  if (imageMap[imageUri]) return imageMap[imageUri];
  if (imageUri.startsWith('data:') || imageUri.startsWith('http')) return imageUri;
  return DEFAULT_CONSULTANT_IMAGE;
}
